import { DebitNotesPage } from './DebitNotesPage';

// Debit Notes are no longer split by B2C / B2B — a single merged list shows both,
// with a Service column and a service-type picker on the Generate form.
export function DebitNotesUnifiedPage() {
  return <DebitNotesPage />;
}
